import { Input } from '@trackman/web-shared-components';

type Props = {
  lessonContent: string;
  id?: string;
  handleLessonContent: (lessonContent: string | undefined) => void;
  handleLessonId: (id: string | undefined) => void;
};

export const ChapterTestField = ({ lessonContent, id, handleLessonContent, handleLessonId }: Props) => {
  return (
    <>
      <Input
        label='Chapter Test Id'
        value={id ?? ''}
        onChange={(e) => handleLessonId(e.currentTarget.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
      />
      <Input
        label='Area9 Entrypoint'
        value={lessonContent || ''}
        required
        onChange={(e) => handleLessonContent(e.currentTarget.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
      />
    </>
  );
};
